import { computed, ComputedRef } from 'vue'

import { useStore } from '@/store'
import { CountryEnum, ModeEnum } from '@/store/modules/settings/types'

// Single source of truth for "mode rapide" (BUILD-800/BUILD-802): shared between the toggle
// (StayListPage.vue) and the staylist row click behavior (McoStayListLine.vue) so they can't drift.
export default function useQuickMode(mode: ComputedRef<ModeEnum>) {
  const store = useStore()
  const country = computed(() => store.state.settings.pmsi.country)
  const userSettings = computed(() => store.state.settings.userSettings)

  const isQuickModeAvailable = computed(() => country.value === CountryEnum.FR
    && [ModeEnum.OPTIMIZABLE, ModeEnum.DIALYSIS].includes(mode.value))
  const isQuickModeEnabled = computed(() => isQuickModeAvailable.value
    && (userSettings.value.stayListQuickMode ?? []).includes('enabled'))

  return { isQuickModeAvailable, isQuickModeEnabled }
}
